<template>
  <div v-cloak>
    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          v-has-permission="permission765"
          :columns="[
            { title: $t('FullName') },
            { title: $t('Email') },
            { title: $t('MobileNumber') },
            { title: $t('Title') },
            { title: $t('Answer'), sort: 'Answer' },
            { title: $t('CreateOn'), sort: 'CreateOn' },
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width: 22%">{{ row.fullName }}</td>
            <td style="width: 22%">
              {{ row.emailAddress }}
            </td>
            <td style="width: 11%">
              {{ row.mobileNumber }}
            </td>
            <td style="width: 11%">
              {{ row.header }}
            </td>
            <td style="width: 11%">
              <vs-button
                color="success"
                type="gradient"
                icon-pack="feather"
                class="bordered-btn"
                v-has-permission="permission768"
                @click.prevent="onShowAnswerPopup(row)"
                >{{ $t("ViewAnswers") }}</vs-button
              >
            </td>
            <td style="width: 11%; direction: ltr">
              {{ row.createOn.split(" ")[0] }}<br />{{
                row.createOn.split(" ")[1]
              }}
            </td>
          </template>
        </data-grid>
      </div>
    </div>
    <AnswerPopup
      :show="showAnswerPopup"
      @finish="onfinish"
      :currentSuggestion="currentSuggestion"
    ></AnswerPopup>
  </div>
</template>

<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import AnswerPopup from "./AnswerPopup.vue";

export default {
  name: "",
  components: {
    DataGrid,
    AnswerPopup,
  },
  data() {
    return {
      permission765: "GetAllSuggestions",
      permission768: "AssignAnswer",
      showAnswerPopup: false,
      currentSuggestion: {},
      gridDataSource: {
        type: "app",
        service: "CMS/api/SuggestionsQuery",
      },
      gridSearchData: {},
    };
  },

  methods: {
    onfinish() {
      this.showAnswerPopup = false;
    },
    onShowAnswerPopup(row) {
      this.currentSuggestion = row;
      this.showAnswerPopup = true;
    },
  },
};
</script>
